(function () {
  window.dataLayer = window.dataLayer || [];

  function gtag() {
    window.dataLayer.push(arguments);
  }

  function update(analyticsAllowed, marketingAllowed) {
    var ads = marketingAllowed ? 'granted' : 'denied';
    gtag('consent', 'update', {
      ad_storage: ads,
      ad_user_data: ads,
      ad_personalization: ads,
      analytics_storage: analyticsAllowed ? 'granted' : 'denied'
    });
  }

  document.addEventListener('visitorConsentCollected', function (event) {
    var detail = event.detail || {};
    update(detail.analyticsAllowed, detail.marketingAllowed);
  });

  if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
    if (error) return;
    var privacy = window.Shopify.customerPrivacy;
    update(privacy.analyticsProcessingAllowed(), privacy.marketingAllowed());
  });
})();
